<template>
	<div class="w1" style="max-width: 1232px;width: 1232px;">
	<div  class="Main_wrapper"><!-- Main_wrapper -->
		<ul class="title1">
			<li class="L">中经数说</li>
			<li class="R"></li>
		</ul>
		<itemsearch @showzixunjianyifromsearch="showfankui" v-bind:colid='colid' v-bind:colname='colname' v-bind:colfrom="'shushuo'" @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
		<div v-show="!searchResultShow">
			<el-skeleton :rows="20" :loading="loadingMask" animated :throttle="500">
				<div class="zjss_list" style="min-height: 480px;">
					<ul>
						<li v-for="(result,index) in resultDataList.data" :key="result.id" >
							<a @click="jumppush('/detail/'+result.id+'/1?favtype=3&col=shushuo')" target="_blank">
								<h4 style="padding: 11px 16px;">
									<p style="width: 280px; height: 26px;font-size: 16px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="result.title">
										<!-- <div style="display: table;height: 64px;font-size: 20px;">
											<span style="display: table-cell;vertical-align: middle;"> -->
												<!-- {{result.title&&result.title.length>28?result.title.substring(0,27)+'...':result.title}} -->
												{{result.title}}
											<!-- </span>
										</div> -->
									</p>
								</h4>
								<img :src="resultDataList.images[result.id]?resultDataList.images[result.id]:'images/zjss_echart.png'" alt="" style="width: 378px;height: 284px;"/>
							</a>
						</li>
						
					</ul>
				</div>
	
	
	
				
	
	
				<el-row class="pagediv">
					<el-pagination
								@size-change="changePageSize"
								@current-change="changeSearchPage"
								:current-page="pageNum"
								:page-sizes="[6, 12, 18]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="totalResultCount">
							</el-pagination>
				</el-row>
		
			</el-skeleton>
		</div>
	</div><!-- /Main_wrapper -->
	</div>		
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				hasPower:true,
				loadingMask: true,
				colid:'29c664145734422bbb342b5d1651cf2a',
				colname:'数说',
				pageNum: 1,
				pageSize: 6,
				totalResultCount: 0,
				resultDataList: [],
				searchResultShow:false,
			}
		},
		components:{
			itemsearch,
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='数说-中经专网';
			this.$track([
				['pagetype','数说列表'],
				['reqtype','2'],
				['column',this.colid]
			]);
			this.searchfnc();
			
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('shushuo')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID:this.colid,
							isTopArticle: '1',
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy:'publishtime',
							isDesc:'1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
			// getuserinfofnc: function() {
			// 	let _this = this;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'UserInfo/getUserInfo',
			// 			responseType: 'json',
			// 			params: {
							
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.searchfnc();
			// 			// debugger;
			// 			var tempinfo={
			// 				userAccountID:response.data.data.data.userAccountID,
			// 				username:response.data.data.data.username,
			// 				usertype:response.data.data.data.usertype,
			// 				outUrl:response.data.data.data.outUrl
			// 			}
			// 			_this.$cookies.set('userinfo',tempinfo);
			// 		})
			// 		.catch(function(error) {
			// 			console.log(error);
			// 		});
			// },
		}
	}
</script>

<style>
	
</style>
